import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageService } from './services/page/page.service';
import { PreferencesService } from './services/preferences/preferences.service';
import { ThemeService } from './services/theme/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    public busy: boolean = false;
    public pageService = inject(PageService);
    public preferences = inject(PreferencesService);
    private readonly themeService = inject(ThemeService);

    constructor() {
        this.preferences.initialize();
        this.pageService.loading.subscribe((value) => {
            this.busy = value;
        });
        this.themeService.setInitialTheme();
    }
}
